import React from "react"
import { useFormik } from "formik"
import { Col, Form, Row } from "reactstrap"

import { AutoComplete } from "components/AutoComplete"
import { Button } from "components/Button"
import FormikErrorText from "components/FormikErrorText/FormikErrorText"
import { Modal } from "components/Modal"
import {
   Colors,
   FIELDS_NAME,
   initialValues,
   validationSchema,
} from "./FormConfig"

const TITLES = {
   MODAL_ADD_TITLE: "Add New Mould",
   MODAL_UPDATE_TITLE: "Update Mould",
   ADD_BTN_TEXT: "Add Mould",
   UPDATE_BTN_TEXT: "Update Mould",
}

const ManageMoulds = ({
   isDetailView = false,
   isOpen = false,
   onToggleModal = () => {},
   onSuccess = () => {},
   colors = null,
   id = "",
   isLoading = false,
}) => {
   const formik = useFormik({
      enableReinitialze: true,
      initialValues: {
         ...initialValues,
      },
      validationSchema: validationSchema,
      onSubmit: values => {
         handleSubmit(values)
      },
   })

   const handleSubmit = values => {
      onSuccess(values.color)
   }
   const colorOptions = Object.entries(Colors)
      .map(([label, color]) => ({
         label,
         value: label,
         color,
      }))
      .filter(item => !colors.includes(item.value))

   return (
      <Modal
         isOpen={isOpen}
         customButton={true}
         handleModalToggling={onToggleModal}
         hideModalHeaderSeparator={true}
         headerClasses="header-container justify-content-center mb-0 pt-3"
         sizeClasses="2"
         backdrop="static"
         modalTitle={!!id ? TITLES.MODAL_UPDATE_TITLE : TITLES.MODAL_ADD_TITLE}
      >
         <div className="p-3">
            <Row>
               <Col xs={12}>
                  <Form onSubmit={formik.handleSubmit}>
                     <Row className="mb-3 align-items-center mb-5">
                        <label className=" col-md-3 col-form-label clr-theme-primary">
                           Select Color
                        </label>
                        <div className="col-md-9">
                           <AutoComplete
                              name={FIELDS_NAME.COLOR}
                              options={colorOptions}
                              isDisabled={isDetailView}
                              value={formik.values[FIELDS_NAME.COLOR]}
                              onChange={value =>
                                 formik.setFieldValue(FIELDS_NAME.COLOR, value)
                              }
                              formatOptionLabel={(option, { context }) => {
                                 if (option.color) {
                                    return (
                                       <div className="mould-option mould-radius">
                                          <div
                                             style={{
                                                backgroundColor: option?.color,
                                             }}
                                          />
                                          <p> {option.label} </p>
                                       </div>
                                    )
                                 }
                                 return option.label
                              }}
                              placeholder="Select a color"
                              className="w-100"
                           />
                           <FormikErrorText
                              formikInstance={formik}
                              fieldName={FIELDS_NAME.COLOR}
                           />
                        </div>
                     </Row>

                     <div className="d-flex justify-content-center mt-3 mt-2">
                        <Button
                           isLoading={isLoading}
                           type={"submit"}
                           title={
                              id ? TITLES.UPDATE_BTN_TEXT : TITLES.ADD_BTN_TEXT
                           }
                           className="header-button"
                           onClick={isDetailView && handleModalClose}
                        />
                     </div>
                  </Form>
               </Col>
            </Row>
         </div>
      </Modal>
   )
}

export default ManageMoulds
